export default {
	configTasks: {
		add: "Додати",
		addTask: "Створити завдання",
		editTask: "Редагувати завдання",
		editParams: "Редагувати параметри",
		delete: "Видалити",
		view: "Вигляд",
		compact: "Оптимальний",
		full: "Повний",
		export: "Експорт",
		insert: "Додати",
		insertTooltip: "Скрипт додавання завдань",
		delete: "Видалити",
		deleteTooltip: "Скрипт видалення завдань",
		noTasksError: "Не вибрано жодного завдання",
		deleteWarning: "Ця дія видалить це завдання",
		attention: "Увага",
		cancel: "Скасувати",
		taskDeleted: "Завдання видалене, уточніть Cron",
		paramsEdited: "Параметри змінені, уточніть Cron",
		yes: "Так",
		no: "Ні"
	},
	configTree: {
		selectActionWithBase: "Виберіть дію з базою:",
		untieBaseAndDelete: "Відв'язати базу від програми і видалити",
		untieBase: "Відв'язати базу від програми",
		untieBaseFromAllAppsAndDelete: "Відв'язати базу від всіх програм і видалити",
		untieBaseFromAllApps: "Відв'язати базу від всіх програм",
		cancel: "Скасувати",
		selectActionWithApp: "Виберіть дію з програмою:",
		linkedBasesNumber: "Всі прив'язані бази: ",
		selectBaseToUnselect: "Виберіть бази, які відв'язати від програми:",
		unlinkSelectedBases: "Відв'язати вибрані бази від програми",
		selectAllBases: "Вибрати всі бази",
		unselectAllBases: "Очистити всі бази",
		noLinkedBases: "До даної програми не прив'язано баз",
		deleteApp: "Видалити програму",
		enterData: "Введіть дані нової програми. Копіюється:",
		attentionAppCopy: "Увага: копіювання програми виконується в межах одного сервера",
		name: "Назва",
		alias: "Аліас",
		path: "Шлях",
		add: "Додати",
		fastCreate: "Швидке створення бази",
		copy: "Копіювати",
		edit: "Редагувати",
		delete: "Видалити",
		refreshData: "Оновити дані",
		refreshServerSynchrDate: "Оновити дату синхронізації серверів",
		createServer: "Створити сервер",
		exportManagerCfg: "Експорт manager.cfg",
		importManagerCfg: "Перегляд manager.cfg",
		export: "Експорт",
		exportManagerQuestion: "Зробити експорт manager.cfg?",
		exportManagerQuestion: "Створити manager.cfg?",
		managerFileChanged: "Файл manager.cfg змінений вручну. Дата зміни файлу: {fileDate}, дата експорту бази: {baseDate}",
		managerFileUnchanged: "Перезаписати файл manager.cfg? Дата зміни файлу: {fileDate}, дата експорту бази: {baseDate}",
		enterNewAppName: "Введіть назву нової програми",
		enterNewPath: "Введіть шлях нової програми",
		enterNameForBaseFastCreate: "Введіть назву бази для швидкого створення (інші значення за замовчуванням)",
		back: "Назад",
		wrongFormat: "Невірний формат вводу",
		checkAccess: "Перевірте дозволу користувачів для зв'язку з цим. По замовчуванням доступ заборонений",
		desirableEnterAlias: "Бажано заповнювати поле 'Аліас'. Продовжити без заповнення?",
		attention: "Увага",
		continue: "Продовжити",
		comeback: "Повернутися",
		thisActionDeleteServer: "Ця дія видалить цей сервер:",
		cancellation: "Скасувати",
		paramDeleteAction: "Ця дія видалить цей параметр програми:",
		usersPermissionsDeleted: "Дозволи користувачів для зв'язку з цим видалені",
		operationNotSelected: "Не обрана операція",
		selectAppForUnlink: "Виберіть програму для відв'язування",
		selectBaseForUnlink: "Виберіть базу для відв'язування",
		selectOperation: "Виберіть операцію",
		checkUsersAccessForThisLink: "Перевірте дозволу користувачів для зв'язку з цим. По замовчуванням доступ заборонений",
		checkAddOK: "Перевір addOk в Config Tree Node",
		serverNotSelected: "не встановлено сервер",
		noTinyAgentOnServer: "На сервері відсутній tiny агент",
	},
	roleSections: {
		role: "Роль:",
		allow: "Дозволити",
		prohibit: "Заборонити",
		view: "Вигляд",
		compact: "Оптимальний",
		full: "Повний",
		tableHeaders: {
			access: "Доступ",
			available: "Доступно",
			base: "База",
			baseAlias: "Аліас бази",
			baseComment: "Коментар до бази",
			app: "Програма",
			appAlias: "Аліас програми",
			appServer: "Сервер програми"
		}
	},
	roleTasks: {
		role: "Роль:",
		allow: "Дозволити",
		prohibit: "Заборонити",
		view: "Вигляд",
		compact: "Оптимальний",
		full: "Повний",
		tableHeaders: {
			access: "Доступ",
		}
	},
	sectionTasks: {
		server: "Сервер:",
		app: "Програма",
		appNotSelected: "Програму не обрано",
		launchAllowed: "Запуск дозволено",
		launchDenied: "Запуск заборонено",
		deniedLaunch: "Заборонити запуск",
		allowLaunch: "Дозволити запуск",
	}
};
